import { forwardRef } from 'react';
import { Button, Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

export const BoostAnalyticsOnboardingHint = forwardRef(
  ({ className, style, onNextClick, dontShowAgain, onDontShowAgainChange }, ref) => {
    const styles = useStyles();

    const handleClose = () => {
      onNextClick();
    };

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
        style={style}
      >
        <Typography className={styles.title}>🚀 Boost copy performance</Typography>

        <Typography className={styles.description}>
          Boost performance instantly by improving your copy with just one click
        </Typography>

        <div className={styles.actionButtons}>
          <FormControlLabel
            className={styles.showToggle}
            control={<Checkbox color="primary" />}
            label="Don't show again"
            checked={dontShowAgain}
            onChange={onDontShowAgainChange}
          />

          <Button
            className={styles.closeButton}
            color="primary"
            variant="contained"
            onClick={handleClose}
          >
            Close
          </Button>
        </div>
      </div>
    );
  }
);

BoostAnalyticsOnboardingHint.propTypes = {
  className: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
  dontShowAgain: PropTypes.bool,
  onDontShowAgainChange: PropTypes.func.isRequired,
};

BoostAnalyticsOnboardingHint.defaultProps = {
  className: null,
  dontShowAgain: false,
};
